import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { InfoTooltip } from 'app/modules/models/infoTooltip.type';
import { environment } from 'environments/environment';


@Injectable({
    providedIn: 'root'
})
export class InfoTooltipService {

    protected apiRoute = environment.RESOURCE_API;

    constructor(private _httpClient: HttpClient) {
    }


    getAllActiveByPage(page: string): Observable<InfoTooltip[]> {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.getByPage + page;
        return this._httpClient.get<InfoTooltip[]>(route, this.prepareHeader());
    }

    getAllActive(): Observable<InfoTooltip[]> {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.getAllActive;
        return this._httpClient.get<InfoTooltip[]>(route, this.prepareHeader());
    }

    add(infoTooltip: InfoTooltip) {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.add;
        return this._httpClient.post(route, infoTooltip, this.prepareHeader()).pipe(map(res => res as any));
    }

    delete(infoTooltip: InfoTooltip) {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.delete;
        return this._httpClient.post(route, infoTooltip, this.prepareHeader()).pipe(map(res => res as any));
    }
    getActiveByName(name: string): Observable<InfoTooltip> {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.getByName + name;
        return this._httpClient.get<InfoTooltip>(route, this.prepareHeader());
    }
    getActiveByButtonId(buttonId: string): Observable<InfoTooltip> {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.getByButtonId + buttonId;
        return this._httpClient.get<InfoTooltip>(route, this.prepareHeader());
    }
    update(infoTooltip: InfoTooltip) {
        const route = this.apiRoute + environment.apiCatalog.infoTooltip.subRoutes.update;
        return this._httpClient.put(route, infoTooltip, this.prepareHeader()).pipe(map(res => res as any));
    }

    private prepareHeader(): Object {
        let headers = new HttpHeaders();


        headers = headers.set('Accept', 'application/json');


        const token = sessionStorage.getItem('simulator_token');
        if (token) {
            headers = headers.set('simulatorToken', token);
        }

        return { headers: headers };


    }
}
